import * as React from "react";
import {Component} from "react";
import styles from "../styles/wizards/AddStoreyWizard.scss";
import autobind from "autobind-decorator";
import AddStoreyIcon from "../assets/images/add-storey-60x60.svg";
import {__, mapStateToProps, setTableParams, validateForm} from "../core/utils";
import {withRouter} from "react-router";
import {getStagesLanguages} from "../redux/actions/table/stages";
import {setNotification} from "../redux/actions/general/notification";
import {createStorey, listStoreys} from "../redux/actions/table/storeys";
import AddStoreyForm from "../forms/add_storey_wizard/AddStoreyForm";

@withRouter
@mapStateToProps(state => ({
	table: state.table["storeys"],
}))
class AddStoreyWizard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			project_languages: null
		}
	}

	componentDidMount() {
		getStagesLanguages(this.props.match.params.stage).then(({response}) => {
			this.setState({project_languages: response.data});
		});
	}

	@autobind
	_handleSubmit(formData) {
		const {edit} = formData;

		formData = _.omit(formData, ['edit']);

		return validateForm(
			createStorey(this.props.match.params.stage, formData).then(({response}) => {
				listStoreys(this.props.match.params.stage).then(() => {
					if(edit) {
						setTableParams('storeys', {
							clicked_row: response.data.id
						});
					}
				});

				setTableParams('storeys', {
					actioned_row: undefined,
					selected_rows: []
				});

				this.props.onClose();

				setNotification(__("wizard.add-storey.message.success"));
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>{__('wizard.add-storey.title.add-new-storey')}</span>
						<span>{__('wizard.add-storey.subtitle.add-new-storey')}</span>
					</div>
					<div className={styles.right}>
						<AddStoreyIcon />
					</div>
				</div>
				<div className={styles.body}>
					{this.state.project_languages && <AddStoreyForm
						projectLanguages={this.state.project_languages}
						onSubmit={this._handleSubmit}
						initialValues={{
							name: {},
							description: {},
						}}
					/>}
				</div>
			</>
		);
	}
}

export default AddStoreyWizard;